export default "__VITE_ASSET__BrXftCXC__"